import {
  Bars3Icon,
  MuiIconButton,
  SlideOut,
  Typography
} from "@dealer-center/core-components";
import { useState } from "react";
import { LinksMenuNew } from "./links-menu-new";
import { useNavBarStore } from "../../store";

export const Navigation = () => {
  const { hasBridgeBar, visibility } = useNavBarStore();
  const [anchorNavigationEl, setNavigationAnchorEl] =
    useState<null | HTMLElement>(null);
  const isNavigationMenuOpen = Boolean(anchorNavigationEl);

  const handleNavigationMenuClose = () => {
    setNavigationAnchorEl(null);
  };

  const handleNavigationMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setNavigationAnchorEl(event.currentTarget);
  };
  const renderNavigationMenu = (
    <SlideOut
      hasBridgeBar={hasBridgeBar}
      header={"Dealer Center"}
      position={"left"}
      show={isNavigationMenuOpen}
      sx={{
        "&>div>div": {
          ":first-of-type": {
            pl: 2,
            pr: 2
          },
          pl: 1,
          pr: 1
        }
      }}
      onHide={handleNavigationMenuClose}
    >
      <LinksMenuNew closeNavbar={handleNavigationMenuClose} />
    </SlideOut>
  );

  return (
    <>
      <MuiIconButton
        aria-label="Open navigation menu"
        color="inherit"
        edge="start"
        size="large"
        sx={{
          mr: 2,
          borderRight: visibility.shouldNavigationBeAnIcon
            ? ""
            : "1px solid #ffffff99",
          borderRadius: 0
        }}
        onClick={handleNavigationMenuOpen}
      >
        <Bars3Icon title="Menu" />
        {!visibility.shouldNavigationBeAnIcon && (
          <Typography
            sx={{
              color: "white",
              fontWeight: "normal",
              paddingLeft: 1
            }}
            variant="h3"
          >
            Menu
          </Typography>
        )}
      </MuiIconButton>
      {renderNavigationMenu}
    </>
  );
};
